import { Select } from 'antd';
import { useCallback, useState } from 'react';
import './PlansSearchSelect.scss';
import { apiSplitPlans } from '../../../api/splitPlans';

const { Option } = Select;

const PlansSearchSelect = ({
    value,
    onChange,
    placeholder = "Selecione um plano",
    hasError = false,
    disabled = false,
    notFoundText = "Nenhum resultado encontrado",
    allowClear = false,
    errorMessage = null,
    ...props
}) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchOptions = useCallback(async (searchValue = '') => {
        setLoading(true);
        try {
            const response = await apiSplitPlans({ search: searchValue, page_size: 100 });

            setOptions(response.results.map(item => ({
                value: item.id,
                label: item.name
            })));
        } catch (error) {
            console.error("Erro ao buscar planos:", error);
            setOptions([]);
        } finally {
            setLoading(false);
        }
    }, []);

    const handleDropdownVisibleChange = async (visible) => {
        if (visible) {
            await fetchOptions('');
        }
    };

    const handleSearch = async (searchValue) => {
        await fetchOptions(searchValue);
    };

    const getDisplayName = (value) => (value && value.name) || placeholder;

    const onSelectChange = (selectedValue) => {
        const selectedOption = options.find(option => option.value === selectedValue);
        if (selectedOption) {
            onChange({
                id: selectedOption.value,
                name: selectedOption.label
            });
        } else {
            onChange(null);
        }
    }

    return (
        <div className="plans-search-select">
            <div className='input-container'>
                <Select
                    showSearch
                    value={getDisplayName(value)}
                    className={hasError ? 'error-select' : ''}
                    placeholder={placeholder}
                    onChange={onSelectChange}
                    onSearch={handleSearch}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                    notFoundContent={loading ? "Carregando..." : notFoundText}
                    style={{ width: '100%' }}
                    filterOption={false}
                    loading={loading}
                    disabled={disabled}
                    allowClear={allowClear}
                    {...props}
                >
                    {options.map(option => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            </div>
            {hasError && errorMessage && (
                <div className="error-text">{errorMessage}</div>
            )}
        </div>
    );
};

export default PlansSearchSelect;
